module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动标题"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "maxlength": 50,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动内容"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "type": "textarea",
      "maxlength": 300,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.form.desc_txt),
      callback: function($$v) {
        _vm.$set(_vm.form, "desc_txt", $$v)
      },
      expression: "form.desc_txt"
    }
  })], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog2,
      "sc-status": _vm.isGetImage2
    },
    on: {
      "chooseImg": _vm.pickImg2,
      "closeImgDialog": _vm.closeImgDialog2
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "背景图片",
      "hide-requied-aterisk": "true"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.handleImgPicker2
    }
  }, [(_vm.form.backend_img) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.backend_img
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })])]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分享图片",
      "hide-requied-aterisk": "true"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.handleImgPicker
    }
  }, [(_vm.form.share_img) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.share_img
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分享文字"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "type": "textarea",
      "maxlength": 300,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.form.share_desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "share_desc", $$v)
      },
      expression: "form.share_desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.form.times),
      callback: function($$v) {
        _vm.$set(_vm.form, "times", $$v)
      },
      expression: "form.times"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动类型"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("新客专区")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("社群专区")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否关联商品"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.rel_items_flag),
      callback: function($$v) {
        _vm.$set(_vm.form, "rel_items_flag", $$v)
      },
      expression: "form.rel_items_flag"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("关联")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("不关联")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "次数限制"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.form.user_one_limit),
      callback: function($$v) {
        _vm.$set(_vm.form, "user_one_limit", $$v)
      },
      expression: "form.user_one_limit"
    }
  }), _vm._v(" "), _c('el-tag', [_vm._v("(每人参与次数限制,0不限制)")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "总人数"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.form.user_all_limit),
      callback: function($$v) {
        _vm.$set(_vm.form, "user_all_limit", $$v)
      },
      expression: "form.user_all_limit"
    }
  }), _vm._v(" "), _c('el-tag', [_vm._v("(活动总人数限制，0不限制)")])], 1), _vm._v(" "), _c('el-card', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.showCoupons
    }
  }, [_vm._v("选择优惠券+")])], 1), _vm._v(" "), (_vm.sendInfo) ? _c('div', {
    staticClass: "text item"
  }, _vm._l((_vm.sendInfo), function(item, index) {
    return _c('el-tag', {
      key: item.id,
      attrs: {
        "closable": "",
        "type": "success"
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(item)
        }
      }
    }, [_vm._v("\n                    ID:" + _vm._s(item.id) + " : " + _vm._s(item.title) + "\n                ")])
  }), 1) : _vm._e()]), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "绑定商品",
      "shadow": "naver"
    }
  }, [_c('SkuSelector', {
    attrs: {
      "data": _vm.relItems
    },
    on: {
      "change": _vm.getItems
    }
  }), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "line-height": "normal"
    },
    attrs: {
      "data": _vm.form.items
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "item_id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品货号",
      "prop": "item_bn"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "prop": "item_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类型",
      "prop": "special_type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.special_type == 'drug') ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("处方药")]) : _c('span', {
          staticStyle: {
            "color": "blue"
          }
        }, [_vm._v("非处方药")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动价"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "min": "0.01",
            "onkeyup": "value=value.replace(/[^\\d{1,}\\.\\d{1,}|\\d{1,}]/g,'')"
          },
          model: {
            value: (scope.row.activity_price),
            callback: function($$v) {
              _vm.$set(scope.row, "activity_price", $$v)
            },
            expression: "scope.row.activity_price "
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "iconfont icon-trash-alt",
          on: {
            "click": function($event) {
              return _vm.deleteItemRow(scope.$index, _vm.form.items)
            }
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancelSubmit
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('couponPicker', {
    attrs: {
      "visible": _vm.couponsVisible
    },
    on: {
      "pickCoupon": _vm.pickCoupon,
      "closeDialog": _vm.closeDialogs
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-05c3630c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05c3630c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/cardticket/newcustomer/edit.vue
// module id = 2437
// module chunks = 0